
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/providers",
      function () {
        return require("private-next-pages/providers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/providers"])
      });
    }
  